import { Record } from 'immutable'

export const SET_USER = 'SET_USER'

/**
 * Reducer section
 */
const initialState = {
  email: '',
  username: '',
  familyName: '',
  givenName: '',
  password: '',
  passwordConfirmation: '',
}

const User = new Record(initialState)

// FlowType
type Action = {
  type: string,
  payload: {
    user: User,
  },
}

// FlowType
type Action = {
  type: string,
  payload: {},
}

export function reducer(state: Record = initialState, action: Action) {
  switch (action.type) {
    case SET_USER:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setUser(payload: User) {
  return {
    type: SET_USER,
    payload,
  }
}
